module.exports = __webpack_public_path__ + "static/img/ma02.ec87d85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/photographing/ma02.jpg
// module id = OFMq
// module chunks = 0